var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogleSquare = function SvgGoogleSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 5a5 5 0 0 0-5-5H5a5 5 0 0 0-5 5v22a5 5 0 0 0 5 5h22a5 5 0 0 0 5-5V5Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.83 16.182c0-.567-.051-1.113-.145-1.637H16.15v3.095h4.305a3.68 3.68 0 0 1-1.596 2.415v2.007h2.585c1.513-1.393 2.386-3.444 2.386-5.88Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.15 24c2.16 0 3.97-.716 5.294-1.938l-2.585-2.007c-.717.48-1.633.763-2.71.763-2.083 0-3.847-1.407-4.476-3.298H9v2.073A7.997 7.997 0 0 0 16.15 24Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.674 17.52a4.81 4.81 0 0 1-.251-1.52c0-.527.09-1.04.25-1.52v-2.073H9.002A7.997 7.997 0 0 0 8.15 16c0 1.29.309 2.513.85 3.593l2.674-2.073Z",
    fill: "#FBBC05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.15 11.182c1.174 0 2.229.403 3.058 1.196l2.294-2.294C20.117 8.793 18.306 8 16.15 8A7.997 7.997 0 0 0 9 12.407l2.673 2.073c.63-1.89 2.393-3.298 4.477-3.298Z",
    fill: "#EA4335"
  })));
};
export default SvgGoogleSquare;